var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.InvestorRegisteredOnSecondaryMarket)?_c('projects-page-primary-market'):_c('projects-page-secondary-market')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }